import { createSlice } from "@reduxjs/toolkit";
import editDoctorDiscountApi from "@custom/rtk-apis/billing/doctorDiscount/editDoctorDiscount";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const editDoctorDiscountSlice = createSlice({
  name: "editDoctorDiscountSlice",
  initialState,
  reducers: {
    cleareditDoctorDiscount: (state) => {
        state.status = "";
        state.result = null;
        state.msg = "";
        state.loading = false;
        state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(editDoctorDiscountApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editDoctorDiscountApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(editDoctorDiscountApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default editDoctorDiscountSlice.reducer;
export const { cleareditDoctorDiscount } = editDoctorDiscountSlice.actions;
